import React from "react";
import { Switch, Route } from "react-router";

import { langCodes } from "../../_common/lang-codes.js";
import Layout from "./layout/Layout.js";
import NewsFeed from "./newsFeed/NewsFeed.js";
import NewsLoader from "./news/NewsLoader.js";
import "./styles/global.css.js";
import Home from "./home/Home.js";
import StaticTextContent from "./common/StaticTextContent.js";
import TutorialsLoader from "./tutorials/list/TutorialsLoader.js";
import TutorialLoader from "./tutorials/item/TutorialLoader.js";
import QuizLoader from "./games/quiz/QuizLoader.js";
import OutcomeQuizLoader from "./games/outcome-quiz/OutcomeQuizLoader.js";
import GamesLoader from "./games/list/GamesLoader.js";
import ImagePage from "./gallery/ImagePage.js";
import InfographicsPage from "./infographics/InfographicsPage.js";
import InfographicsFeed from "./infographics/InfographicsFeed.js";
import Contacts from "./contacts/Contacts.js";
import About from "./about/About.js";
import Sitemap from "./sitemap/Sitemap.js";
import SearchPage from "./search/SearchPage.js";
import TopicPage from "./topics/TopicPage.js";
import GlobalContextsProvider from "./GlobalContextsProvider.js";
import MoonCalendar from "./moon-calendar/MoonCalendar.js";
import NotFoundErrorMsg from "./common/errors/NotFoundErrorMsg.js";
import AppConfigProvider from "./AppConfigProvider.js";
import HtmlGA4 from "./helmet/third-party/HtmlGA4.js";
import HtmlAppleIcons from "./helmet/HtmlAppleIcons.js";
import HtmlFacebookPixel from "./helmet/third-party/HtmlFacebookPixel.js";
// import HtmlGoogleAds from "./helmet/third-party/HtmlGoogleAds.js";
// import HtmlHotJar from "./helmet/third-party/HtmlHotJar.js";
import HtmlInit from "./helmet/HtmlInit.js";
import HtmlTermly from "./helmet/third-party/HtmlTermly.js";
import { RoutePath } from "../../_common/types.js";

const langParam = `/:lang(${langCodes.join("|")})`;

interface RouteConfig {
    path: "" | `/${RoutePath}` | `/${RoutePath}/:id`;
    component?: React.FC;
    render?: () => React.ReactElement;
}

const AppRoot: React.FC = () => {
    const routes: RouteConfig[] = [
        { path: "", component: Home },
        { path: "/news", component: NewsFeed },
        { path: "/news/:id", component: NewsLoader },
        { path: "/tutorials", component: TutorialsLoader },
        { path: "/tutorials/:id", component: TutorialLoader },
        { path: "/games", component: GamesLoader },
        { path: "/quiz/:id", component: QuizLoader },
        { path: "/outcome-quiz/:id", component: OutcomeQuizLoader },
        { path: "/image/:id", component: ImagePage },
        { path: "/infographics", component: InfographicsFeed },
        { path: "/infographics/:id", component: InfographicsPage },
        { path: "/moon-calendar", component: MoonCalendar },
        { path: "/about", component: About },
        { path: "/contacts", component: Contacts },
        { path: "/search", component: SearchPage },
        { path: "/sitemap", component: Sitemap },
        { path: "/topics/:id", component: TopicPage },
        {
            path: "/privacy-policy",
            render: () => (
                <StaticTextContent
                    id="vito-privacy-policy"
                    path="/privacy-policy"
                />
            ),
        },
        {
            path: "/terms-of-use",
            render: () => (
                <StaticTextContent
                    id="vito-terms-of-use"
                    path={"/terms-of-use"}
                />
            ),
        },
    ];

    return (
        <GlobalContextsProvider>
            <AppConfigProvider>
                <HtmlInit />
                <HtmlTermly />
                {/* <HtmlHotJar /> */}
                <HtmlAppleIcons />
                <HtmlGA4 />
                {/* <HtmlGoogleAds /> */}
                <HtmlFacebookPixel />
                <Switch>
                    <Route
                        sensitive={true}
                        path={langParam}
                        render={({
                            match: {
                                params: { lang },
                            },
                        }) => (
                            <Layout>
                                <Switch>
                                    {routes.map(
                                        ({ path, component, render }) => (
                                            <Route
                                                key={path}
                                                path={`/${lang}${path}`}
                                                component={component}
                                                render={render}
                                                sensitive={true}
                                                exact={true}
                                                strict={true}
                                            />
                                        ),
                                    )}
                                    <Route
                                        render={() => <NotFoundErrorMsg />}
                                    />
                                </Switch>
                            </Layout>
                        )}
                    />
                    <Route
                        sensitive={true}
                        render={() => (
                            <Layout>
                                <NotFoundErrorMsg />
                            </Layout>
                        )}
                    />
                </Switch>
            </AppConfigProvider>
        </GlobalContextsProvider>
    );
};
export default AppRoot;
